var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefit3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 48,
    width: 13,
    height: 20,
    rx: 3,
    fill: "#53CDFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 38,
    width: 13,
    height: 30,
    rx: 3,
    fill: "#00B4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28,
    width: 13,
    height: 40,
    rx: 3,
    fill: "#00638C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 0l1.463 6.748a2.337 2.337 0 001.789 1.789L74 10l-6.748 1.463a2.337 2.337 0 00-1.789 1.789L64 20l-1.463-6.748a2.337 2.337 0 00-1.789-1.789L54 10l6.748-1.463a2.337 2.337 0 001.789-1.789L64 0zM53 14l.572 2.64a2.337 2.337 0 001.789 1.788L58 19l-2.64.572a2.337 2.337 0 00-1.788 1.789L53 24l-.572-2.64a2.337 2.337 0 00-1.789-1.788L48 19l2.64-.572a2.337 2.337 0 001.788-1.789L53 14z",
    fill: "#325AFF"
  })));
}
export default SvgBenefit3;